import * as _ from 'lodash';
import { Dispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { AuthActionCreators, IApplicationState } from '../';
import { IGpsItemsForList, IGpsItemsForCentralRecords, IBaseResponse, IGPSCounts, IGpsStatusRequest } from '@nkr/models/index';
import { GpsListType } from '@nkr/enums/index';

export interface IGpsItemsResponse {
    data: {
        success: boolean,
        message: string,
        results: IGpsItemsForList[]
    }
}
export interface IGpsItemsCentralRecordsResponse {
    data: {
        success: boolean,
        message: string,
        results: IGpsItemsForCentralRecords[]
    }
}
export interface IGpsCountsResponse {
    data: {
        success: boolean,
        message: string,
        results: IGPSCounts
    }
}

export const ActionCreators = {
    getGpsReportList: (statusType: GpsListType, gpsNumber: string, chainId: string) => (dispatch: Dispatch<IApplicationState>): Promise<IGpsItemsResponse> => {
        let options = {
            url: `${__API__}/admin/gps/get-all-records`,
            data: {
                statusType,
                gpsNumber,
                chainId
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IGpsItemsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getGpsCentralRecords: (startDate: string, endDate: string, category: number, catSearch: string, center: number) => (dispatch: Dispatch<IApplicationState>): Promise<IGpsItemsCentralRecordsResponse> => {
        let options = {
            url: `${__API__}/admin/gps/get-gps-central`,
            data: {
                startDate,
                endDate,
                category,
                catSearch,
                centerId: center
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IGpsItemsCentralRecordsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },


    getGpsExport: (reportType: GpsListType, gpsNumber: string, chainId: string) => async (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/admin/gps/get-all-records?csv=true`,
            data: {
                statusType: reportType,
                gpsNumber,
                chainId
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IGpsItemsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getGpsCounts: () => (dispatch: Dispatch<IApplicationState>): Promise<IGpsCountsResponse> => {
        let options = {
            url: `${__API__}/admin/gps/counts`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IGpsCountsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    markGpsStatus: (gpsStatusRequest: IGpsStatusRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let { id, markStatus, outboundTrackingNumber, returnTrackingNumber, trackingNumberType, gpsLink, gpsNumber, gpsComments } = gpsStatusRequest;

        var options = {
            url: __API__ + '/admin/gps/update-gps-status',
            data: {
                id,
                markStatus,
                trackingNumberType,
                outboundTrackingNumber,
                returnTrackingNumber,
                gpsLink,
                gpsNumber,
                gpsComments
            }
        }

        return dispatch(AuthActionCreators.apiPut(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    bulkGpsPrint: (list: number[], batchType: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: __API__ + '/admin/gps/batch-print-gps',
            data: {
                list,
                batchType
            },
            responseType: 'blob'
        }

        return dispatch(AuthActionCreators.apiPost(options));
    }

}

export interface IGpsState {
}

let initialState: IGpsState = {

};

const createReducer = (initialState: IGpsState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
};

export const Reducer = createReducer(initialState, handlers);
